import { render, staticRenderFns } from "./orderDetailList.vue?vue&type=template&id=5002bba7"
import script from "./orderDetailList.vue?vue&type=script&lang=js"
export * from "./orderDetailList.vue?vue&type=script&lang=js"
import style0 from "./orderDetailList.vue?vue&type=style&index=0&id=5002bba7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports